module.exports = __webpack_public_path__ + "static/media/James-wong-hero.8471fb4f.jpg";